import { getBotBaseURL, getToken } from "../redux/api";
import type { RawStreamOptions } from "./chatOptions";

export interface CallbackResponse {
  text?: string;
  end: boolean;
  buttons: string[];
  options?: RawStreamOptions | null;
}

interface StreamingApiProps {
  chatId: string;
  msg: string;
  callback: (data: CallbackResponse) => void;
}

export const StreamApi = async ({
  chatId,
  msg,
  callback,
}: StreamingApiProps) => {
  try {
    const token = (await getToken()) || "";
    const botBaseURL = (await getBotBaseURL()) || "";
    const response = await fetch(botBaseURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        session_id: chatId,
        message: msg,
      }),
    });

    if (!response.ok || !response.body) {
      throw new Error("Network response was not ok or body is null");
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");
    let buffer = "";

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });

      const lines = buffer.split("\n");

      for (let i = 0; i < lines.length - 1; i++) {
        const line = lines[i].trim();

        if (line.startsWith("event:")) {
          const eventType = line.slice(6).trim();
          const dataLine = lines[i + 1]?.trim();
          if (dataLine?.startsWith("data:")) {
            const jsonData = dataLine.slice(5).trim();
            const parsed = JSON.parse(jsonData);

            if (eventType === "on_stream_start") {
              callback({ ...parsed, end: false });
            } else if (eventType === "on_stream_end") {
              if (parsed.text === "--Done--" || parsed.text === "--DONE--") {
                callback({
                  buttons: [],
                  end: true,
                  options: parsed.options ?? null,
                });
              }
            }
          }
        }
      }
      buffer = lines[lines.length - 1];
    }
  } catch (error) {
    console.error("Error in StreamApi:", error);
  }
};
